import { Directive, ElementRef, Input, NgModule, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[systemButton]',
  host: {
    class:
      ' font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none focus:ring-4 disabled:opacity-50 disabled:cursor-not-allowed',
  },
})
export class ButtonDirective implements OnChanges {
  @Input({ required: true }) buttonType: 'primary' | 'secondary' | 'quinary' | 'custom' = 'primary';
  private classes = {
    primary:
      'bg-system-400 text-white hover:enabled:bg-system-800 border border-system-400 focus:ring-system-300 dark:bg-system-600 dark:hover:enabled:bg-system-400 dark:focus:ring-system-800',
    secondary:
      'bg-white hover:enabled:bg-system-100 border border-system-400 text-system-400 focus:ring-gray-300 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800',
    quinary:
      'bg-gray-700 text-white hover:enabled:bg-gray-800 focus:ring-gray-300 dark:bg-gray-600 dark:hover:enabled:bg-gray-700 dark:focus:ring-gray-800',
  };

  constructor(private el: ElementRef<HTMLButtonElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.buttonType !== 'custom' && changes['buttonType']) {
      this.el.nativeElement.classList.add(...this.classes[this.buttonType].split(' '));
    }
  }
}

@NgModule({
  declarations: [ButtonDirective],
  exports: [ButtonDirective],
})
export class SystemButtonModule {}
